import React from 'react';
import { BsTwitter, BsInstagram } from 'react-icons/bs';
import { FaFacebookF, FaLinkedin} from 'react-icons/fa';
import {SiFiverr} from 'react-icons/si'

const SocialMedia = () => (
  <div className="app__social">
    <div>
     <a href='https://twitter.com/JHON_WICK101?s=09' target='_blank'> <BsTwitter /></a>
    </div>
    <div>
     <a href='https://www.linkedin.com/in/shehzad-munir-codtechit' target='_blank'> <FaLinkedin /></a>
    </div>
    <div>
      <a href='https://www.instagram.com/dexter_9_9/' target='_blank'> <BsInstagram /></a>
    </div>
    <div>
      <a href='https://www.fiverr.com/shehzadkhan438' target='_blank'> <SiFiverr /></a>
    </div>
  </div>
);

export default SocialMedia;
